<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { saleService } from "../../../services/saleservice/sale.service";
import { saletransferService } from "../../../services/saleservice/saletransfer.service";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import i18n from "../../../i18n";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Selling List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      saleTransferData: {},
      fetchingStats: false,
      title: "Selling List",

    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      
      // param = `?clause={"clause":[{"conjuction":"and","sale_transfers.property_id":{"value":${this.$route.params.id}}}]}`;

      this.fetchingStats = false;
      saletransferService.getList(param)
        .then(response => {
          
          // console.log(JSON.stringify(response.data));
          this.fetchingStats = true;
          this.saleTransferData = response;
        });

    },

    deleted: function(id) {
      saleService.remove(id)
        .then(response => {
        
          // this.saleData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    moreSaleTransferClicked: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.approve'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
                
            saletransferService.approve(id).then(response => {
              if(response.status == 200) {
                
                this.loadingSaleTransferData();
                
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.denie'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {

            saletransferService.denie(id).then(response => {
              if(response.status == 200) {
                
                this.loadingSaleTransferData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      }
    },


    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "sale-add",
          });
    },

    //  }, {
    //           name: 'sale.write-off', icon: 'bx bx-x-circle', action: 'writeoff', link: 'property-contract', column: 'id'

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="null"
    :title="$t('sale.transfer-to-other')" />
    <List v-bind:dataList="saleTransferData" 
        v-bind:updating="fetchingStats" 
        v-bind:navigate="pageNavigate"
        v-bind:formats="[{name: 'sell_price', type: 'currency', sign: '$'}, {name: 'status', color: true}, {name: 'for_date', type: 'date'}]"
        v-bind:fields="[ `for_date: ${$t('property.cancelation.date')}`,
          `sale: ${$t('sale.text')}`, 
          `property: ${$t('property.text')}`, 
          `from_name: ${$t('sale.transfer.from-customer')}`, 
          `to_name: ${$t('sale.transfer.to-customer')}`, 
          `sell_price: ${$t('sale.sale-price')}`,
          `reason: ${$t('property.cancelation.notation')}`,
          `status: ${$t('property.status')}`
        ]" 
        @more="moreSaleTransferClicked"
        v-bind:more="{
          sub: [{
            name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'sale_transfer_status_id', value: 1}
          },{
            name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'sale_transfer_status_id', value: 1}
          },{
            name: 'general.print', icon: 'bx bx-file', link: 'report-transfer-sale-print', column: 'id', target: '_blank'
          }] 
        }"
        
        v-bind:filter="{}"
    />   
  </Layout>
</template>

